import {
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ArrowBack from '@material-ui/icons/ArrowBackIos'
import EventIcon from '@material-ui/icons/Event'

import styles from '../../../resources/theme/global'
import { ready } from '../HomeActions'

import ReadyItemsFilter from './ReadyItemsFilter'

function ReadyItems(props) {
  const dispatch = useDispatch()
  const { classes } = props

  useEffect(() => {
    dispatch(ready())
  }, [])

  const items = useSelector(state => state.dashboard.readyItems)

  const renderOsNumber = item => {
    if (item.isLaundry) {
      return <TableCell>{item.id}</TableCell>
    }

    return (
      <TableCell component={Link} to={`/attendance/${item.id}/edit`}>
        {item.id}
      </TableCell>
    )
  }

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={1}
        alignItems="center"
      >
        <Grid item xs>
          <Typography variant="h4" color="secondary">
            OSs prontas para entrega
          </Typography>
        </Grid>
        <Grid item>
          <ReadyItemsFilter classes={classes} />
        </Grid>
        <Grid item>
          <Button color="primary" variant="contained" component={Link} to="/">
            <ArrowBack className={classes.btnIcon} /> Voltar
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs>
          <Paper elevation={1}>
            <TableContainer className={classes.tableContainer}>
              <Table size="medium" className={classes.tableStyle}>
                <TableHead>
                  <TableRow>
                    <TableCell>Número da OS</TableCell>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Atendente</TableCell>
                    <TableCell>Items na OS</TableCell>
                    <TableCell>Items Entregues</TableCell>
                    <TableCell>Items prontos para entrega</TableCell>
                    <TableCell>Data da Coleta</TableCell>
                    <TableCell>Data de entrega</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.map(item => (
                    <TableRow key={item.id}>
                      {renderOsNumber(item)}
                      <TableCell>{item.client_name}</TableCell>
                      <TableCell>{item.attendant_name}</TableCell>
                      <TableCell>{item.total_items}</TableCell>
                      <TableCell>{item.finished_items}</TableCell>
                      <TableCell>{item.delivering_items}</TableCell>
                      <TableCell>{item.collected_at}</TableCell>
                      <TableCell>{item.deadline_date}</TableCell>
                      <TableCell>
                        <IconButton
                          aria-label="calendar"
                          color="primary"
                          component={Link}
                          to={`/calendar/${item.id}`}
                        >
                          <EventIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

export default withStyles(styles)(ReadyItems)
